module.exports = __webpack_public_path__ + "roboto-medium-webfont-6484794cd05bbf97f3f0c730cec21665.woff";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/fonts/roboto/roboto-medium-webfont.woff
// module id = 861
// module chunks = 86